import React from "react"
import PropTypes from "prop-types"

import { ChildSelector } from "../helpers/ChildSelector"

import WPCta from "./_base/WPCta"
import WPImage from "./_base/WPImage"

import * as ourPeopleDetailsStyles from "../styles/OurPeopleDetails.module.css"

function OurPeopleDetails(props) {
  const address = ChildSelector.select(
    props.content,
    `our-people-address`,
    ChildSelector.SELECTOR_TYPE.INNER_HTML
  )

  const phone = ChildSelector.select(
    props.content,
    `our-people-phone`,
    ChildSelector.SELECTOR_TYPE.TEXT
  )

  const info = ChildSelector.select(
    props.content,
    `our-people-personal-information`,
    ChildSelector.SELECTOR_TYPE.INNER_HTML
  )

  const statement = ChildSelector.select(
    props.content,
    `our-people-statement`,
    ChildSelector.SELECTOR_TYPE.INNER_HTML
  )

  return (
    <div
      className={`row ${ourPeopleDetailsStyles.groupwrapper} ${props.className}`}
    >
      <div className={`col-6 ${ourPeopleDetailsStyles.group}`}>
        <div className={`row ${ourPeopleDetailsStyles.subGroup}`}>
          <div className={`col-6 ${ourPeopleDetailsStyles.subGroupDetails}`}>
            <div dangerouslySetInnerHTML={{ __html: address }} />
            <div
              className={`${ourPeopleDetailsStyles.subGroupDetailsPhone}`}
              dangerouslySetInnerHTML={{ __html: phone }}
            />
          </div>
          <div
            className={`col-6 ${ourPeopleDetailsStyles.subGroupContactInfo}`}
          >
            <div dangerouslySetInnerHTML={{ __html: info }} />
            <WPImage
              holder={props.content}
              selector={`our-people-photo`}
              mode={DISPLAY_MODE.normal}
              className={ourPeopleDetailsStyles.photo}
            />
            <WPCta
              holder={props.content}
              selector={`our-people-social-media`}
              className={`${ourPeopleDetailsStyles.socialMedia}`}
              pageContext={props.pageContext}
              modals={props.modals}
            />
          </div>
        </div>
      </div>
      <div className={`col-6 ${ourPeopleDetailsStyles.group}`}>
        <div dangerouslySetInnerHTML={{ __html: statement }} />
      </div>
    </div>
  )
}

export const DISPLAY_MODE = {
  normal: `normal`,
  inline: `inline`,
  lazy: `lazy`,
}

OurPeopleDetails.defaultProps = {
  mode: DISPLAY_MODE.normal,
}

OurPeopleDetails.propTypes = {
  content: PropTypes.object.isRequired,
}

export default OurPeopleDetails
